<template>
  <div class="options-content">
    <OptionElements mobile />
  </div>
</template>
<script>
import OptionElements from "@/widgets/controls/OptionElements.vue";

export default {
  name: "MobileOptionsList",
  components: {
    OptionElements,
  },
};
</script>
